export function Size(size, product, index) {
  return {
    Ativo: 1,
    CodigoPDV: null,
    Descricao: size.Descricao,
    Id: String(index),
    IdEmpresa: size.IdEmpresa,
    IdProduto: product?.Id,
    IdTamanho: size.Id,
    Preco: 0,
    PrecoDesconto: 0,
    QtdPedacos: size.QtdPedacos,
    QtdSabores: size.QtdSabores,
    TipoPizza: size.TipoPizza,
  };
}

export function SizePriceData(tamPrice) {
  return {
    Preco: Number(tamPrice.Preco) || 0,
    PrecoDesconto: Number(tamPrice.PrecoDesconto) || 0,
    CodigoPDV: Number(tamPrice.CodigoPDV) || null,
  };
}

export function NewSizePriceData(tamPrice) {
  return {
    ...SizePriceData(tamPrice),
    IdEmpresa: tamPrice.IdEmpresa,
    IdTamanho: tamPrice.IdTamanho,
    IdProduto: tamPrice.IdProduto,
  };
}
